document.addEventListener('DOMContentLoaded', function documentLoad() {
	function filterPosts(categoryValue) {
		document.getElementById('loadmore-button').style.display = 'none';
		document.getElementById('loadmore-loader').style.display = 'initial';
		const page = document.getElementById('pagination-page').value;
		const offset = document.getElementById('pagination-offset').value;
		const maxPages = document.getElementById('max_page').value;
		const postType = document.getElementById('post_type').value;
		const excludedPostId = document.getElementById('excluded_post_id').value;
		let orderBy = '';
		if (document.getElementById('order_by')) {
			orderBy = document.getElementById('order_by').value;
		}
		const xhr = new XMLHttpRequest();
		xhr.open('POST', ajaxload_params.ajaxurl); //eslint-disable-line
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			if (xhr.status === 200) {
				const response = JSON.parse(xhr.responseText);
				if (response === '0') {
					document.getElementById('loadmore-loader').style.display = 'none';
				} else {
					if (response.html === undefined) {//eslint-disable-line
						document.getElementById('loadmore-loader').style.display = 'none';
					} else {
						document.getElementById('loadmore-button').style.display = 'initial';
						document.getElementById('loadmore-loader').style.display = 'none';
						document.querySelector('#response').insertAdjacentHTML('beforeend', response.html);
						document.getElementById('pagination-page').value = 1;
						document.getElementById('pagination-offset').value = 7;
						document.getElementById('totalCategory').value = response.totalCount;
						if (response.postcount === response.totalCount) {
							document.getElementById('loadmore-button').style.display = 'none';
						} else if (response.postcount < 6) {
							document.getElementById('loadmore-button').style.display = 'none';
						}
						if (parseInt(page, 0) + 1 > parseInt(maxPages, 0)) {
							document.getElementById('loadmore-button').style.display = 'none';
						}
					}
				}
			}
		};

		const ajaxNonce = ajaxload_params.nonce; //eslint-disable-line
		xhr.send(
			`action=filter_posts&post_type=${postType}&page=${page}&offset=${offset}&categoryid=${categoryValue}&order_by=${orderBy}&posts_per_page=7&nonce=${ajaxNonce}&excludedPostId=${excludedPostId}`,
		);
	}

	const filter = document.querySelectorAll('.js-filter-item');
	filter.forEach(function (post) {
		post.addEventListener('click', event => {
			document.getElementById('response').innerHTML = '';
			const categoryValue = event.target.getAttribute('data-category');
			if (categoryValue === '-1') {
				document.getElementById('categoryid').value = '';
			} else {
				document.getElementById('categoryid').value = categoryValue;
			}
			filterPosts(categoryValue);
		});
	});

	const filterMobile = document.getElementById('mobilefilter');
	if (filterMobile) {
		filterMobile.addEventListener('change', function () {
			document.getElementById('response').innerHTML = '';
			const categoryValue = this.value;
			if (categoryValue === '-1') {
				document.getElementById('categoryid').value = '';
			} else {
				document.getElementById('categoryid').value = categoryValue;
			}
			filterPosts(categoryValue);
		});
	}
	const tagsWrappers = document.querySelectorAll('.tags-wrapper');
	tagsWrappers.forEach(function (tagsWrapper) {
		if (tagsWrapper.children[0].children.length === 0) {
			tagsWrapper.children[0].remove();
		}
	});
});
